import { render, staticRenderFns } from "./editAlertModal.vue?vue&type=template&id=38a15525&scoped=true"
import script from "./editAlertModal.vue?vue&type=script&lang=js"
export * from "./editAlertModal.vue?vue&type=script&lang=js"
import style0 from "./editAlertModal.vue?vue&type=style&index=0&id=38a15525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a15525",
  null
  
)

export default component.exports